export default __webpack_public_path__ + "static/media/demo-logo.99849e12.svg";